/**
 * @author eva
 * @since 2021-06-08 14:23:39
 * @Last Modified by: carangleedohyub
 * @Last Modified time: 2023-11-22 14:36:25
 * @format
 */
/** @jsxImportSource @emotion/react */
import { jsx, css } from '@emotion/react';
import { useState } from 'react';
import { Form, Row, Col, Input, Checkbox, Button, Typography } from 'antd';
import _isEmpty from 'lodash/isEmpty';

import { useMobxStores } from '@stores/Stores';
import { MediaQuery, Styles } from '@helpers/StyleHelper';

function LoginPage(props) {
  const { authStore } = useMobxStores();

  const [form] = Form.useForm();

  const [loginDisabled, setLoginDisabled] = useState(true);
  const [logging, setLogging] = useState(false);
  const [keep, setKeep] = useState(true);
  const [loginError, setLoginError] = useState('');

  return (
    <>
      <div css={styles.contentContainer}>
        <div css={styles.container}>
          <Form
            layout="vertical"
            form={form}
            onFieldsChange={onFormFieldsChange}
            scrollToFirstError
          >
            <Row gutter={[8, 8]}>
              <Col span={24}>
                <Form.Item
                  label="아이디"
                  name="username"
                  // rules={[
                  //   {
                  //     required: true,
                  //     message: '이메일 형식의 아이디를 입력해주세요',
                  //   },
                  //   {
                  //     type: 'email',
                  //     message: '올바른 이메일 형식이 아니에요.',
                  //   },
                  // ]}
                >
                  <Input
                    placeholder="아이디(이메일)을 입력해주세요"
                    size="large"
                  />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item
                  label="비밀번호"
                  name="password"
                  rules={[
                    {
                      required: true,
                      message: '비밀번호를 입력해주세요',
                    },
                  ]}
                >
                  <Input.Password
                    placeholder="비밀번호를 입력해주세요"
                    size="large"
                    onPressEnter={onPressEnterPassword}
                  />
                </Form.Item>
                <Form.Item name="stayLoggedIn">
                  <Checkbox
                    checked={keep}
                    onChange={(e) => {
                      setKeep(e.target.checked);
                    }}
                  >
                    로그인 유지
                  </Checkbox>
                </Form.Item>
              </Col>
              <Col span={24} css={styles.buttonContainer}>
                <div className="errorContainer">
                  {!_isEmpty(loginError) && (
                    <Typography.Text type="danger">
                      {loginError}
                    </Typography.Text>
                  )}
                </div>
                <Button
                  size="large"
                  type="primary"
                  block
                  disabled={loginDisabled}
                  onClick={login}
                  loading={logging}
                >
                  로그인 하기
                </Button>
              </Col>
            </Row>
          </Form>
        </div>
      </div>
    </>
  );

  function onFormFieldsChange(changeFields, allFields) {
    const requiredFields = ['username', 'password'];

    let allValidated = true;
    allFields.forEach((field) => {
      if (requiredFields.indexOf(field.name[0]) > -1) {
        if (_isEmpty(field.value) || field.errors.length > 0) {
          allValidated = false;
          return;
        }
      }
    });

    setLoginDisabled(!allValidated);
  }

  function onPressEnterPassword() {
    login();
  }

  async function validateForm() {
    try {
      const values = await form.validateFields();
      return true;
    } catch (errorInfo) {
      console.error('Validation Failed:', errorInfo);
    }
    return false;
  }

  async function login() {
    setLogging(true);
    setLoginError('');
    const validated = await validateForm();
    if (!validated) {
      setLogging(false);
      return;
    }

    try {
      const { username, password } = form.getFieldsValue();
      const result = await authStore.login({
        username,
        password,
        keep,
      });
      // 동작시 메모리 누수 오류뜸
      setLogging(false);
    } catch (error) {
      if (error.code === 401) {
        if (error.message === 'Disable') {
          setLoginError('승인되지 않은 계정입니다. 관리자에게 문의해주세요.');
        } else {
          setLoginError('아이디 혹은 비밀번호가 틀린 것 같아요.');
        }
      }
      setLogging(false);
    }
  }
}

const styles = {
  contentContainer: {
    ...Styles.rowCenterCenter,
  },
  container: {
    maxWidth: 416,
    width: '100%',
    margin: '60px 20px 0 20px',
    [MediaQuery[0]]: {
      marginTop: 40,
    },
    '& .ant-btn-lg': {
      borderRadius: 8,
    },
  },
  buttonContainer: {
    '& .errorContainer': {
      paddingBottom: 28,
    },
  },
};

export default LoginPage;
